// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"a+l4Q","rc-tabs-tab-active":"wRJVD","input-suffix":"_3aoe+","nav-item":"GKP2J","banner-info":"eCUMe","banner-info-logo":"kH72u","banner-info-content":"+CgFc"};